module.exports = __webpack_public_path__ + "img/cve.9d5fd336.png";